import { Box, Stack, Typography } from '@mui/material';
import { IconBrandTelegram } from '@tabler/icons-react';

import type { ILeadExample } from 'src/services/NicheAnalysisService';

export const hidePreviewContacts = (value: string) =>
    value
        .replace(/https?:\/\/\S+|(?:www\.|t\.me\/|telegram\.me\/|wa\.me\/)\S+/gi, '[ссылка скрыта]')
        .replace(/[\w.+-]+@[\w.-]+\.[a-z]{2,}/gi, '[почта скрыта]')
        .replace(/@[a-z0-9_]{4,}/gi, '[контакт скрыт]')
        .replace(/(?:\+?7|8)[\s()-]*(?:\d[\s()-]*){10}|\b\d{10,11}\b/g, '[телефон скрыт]')
        .replace(/\s+/g, ' ')
        .trim();

export default function LeadDemandPreview({ examples }: { examples: ILeadExample[] }) {
    const visible = examples
        .map((example) => ({ ...example, preview: hidePreviewContacts(example.text || '').slice(0, 220) }))
        .filter((example) => example.preview)
        .slice(0, 3);

    if (!visible.length) return null;

    return (
        <Box component="section" aria-label="Примеры запросов" sx={{ borderTop: '1px solid var(--lm-border)', pt: 2 }}>
            <Typography component="h3" sx={{ color: 'var(--lm-text)', fontSize: 17, fontWeight: 750, mb: 0.5 }}>
                Примеры запросов по вашей теме
            </Typography>
            <Typography sx={{ color: 'var(--lm-muted)', fontSize: 13, mb: 1.5 }}>
                Найдены ранее через сервис. Новые лиды появятся после запуска
            </Typography>
            <Stack spacing={1.25}>
                {visible.map((example, index) => (
                    <Box
                        key={`${example.id}-${index}`}
                        component="article"
                        sx={{ border: '1px solid var(--lm-border)', borderRadius: '8px', bgcolor: 'var(--lm-surface)', p: 1.5 }}
                    >
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1, mb: 1 }}>
                            <Typography sx={{ color: 'var(--lm-text)', fontSize: 13, fontWeight: 700 }}>
                                {example.category_icon || '💬'} {example.category || 'Запрос клиента'}
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: 'var(--lm-muted)', fontSize: 12, flexShrink: 0 }}>
                                <IconBrandTelegram size={15} stroke={1.8} aria-hidden="true" /> Telegram
                            </Box>
                        </Box>
                        <Box sx={{ border: '1px solid var(--lm-border)', borderRadius: '8px', px: 1.25, py: 1, boxShadow: '0 2px 10px rgba(68, 73, 103, 0.06)' }}>
                            <Typography sx={{ color: 'var(--lm-text)', fontSize: 14, lineHeight: 1.55, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
                                {example.preview}{example.text.length > 220 ? '…' : ''}
                            </Typography>
                        </Box>
                    </Box>
                ))}
            </Stack>
        </Box>
    );
}
